const Loading = (props: {small?: boolean}) => 
{
  if(props.small)
    return <div className="loader small"></div>;

  return <div className="loader-wrapper"><div className="loader"></div></div>
}

export default Loading;